<!--申诉详情-->
<template>
  <div class="deliveryEnsureDetail">
    <div
      class="panel-wrap">
      <p class="panel-wrap__title">
        <span class="panel-wrap__title--icon"/>
        <span class="panel-wrap__title--text">订单信息</span>
      </p>
      <div class="panel-wrap__content">
        <div class="flex-layout__wrap">
          <div class="flex-layout__wrap--item">
            <label>订单：</label>
            <span>{{ compensationNorAppealDetail.orderInfo.orderNo }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label suffix-colon>{{$t('cpp')}}</label>
            <span>{{ compensationNorAppealDetail.orderInfo.carBrand }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label suffix-colon>{{$t('pjmc')}}</label>
            <span>{{ compensationNorAppealDetail.orderInfo.partsName }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label suffix-colon>{{$t('sl')}}</label>
            <span>{{ compensationNorAppealDetail.orderInfo.count }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>处理时间：</label>
            <span>{{ compensationNorAppealDetail.orderInfo.createTime | dateFormat }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 一审信息 -->
    <div
      class="panel-wrap">
      <p class="panel-wrap__title">
        <span class="panel-wrap__title--icon"/>
        <span class="panel-wrap__title--text">一审信息</span>
      </p>
      <div class="panel-wrap__content">
        <div class="flex-layout__wrap">
          <div class="flex-layout__wrap--item">
            <label>赔付状态：</label>
            <span>{{ compensationNorAppealDetail.checkInfo.status }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>赔付金额：</label>
            <span>{{ `${compensationNorAppealDetail.checkInfo.compensationAmount}元` }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>赔付原因：</label>
            <span>{{ compensationNorAppealDetail.checkInfo.compensationReason }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>赔付创建时间：</label>
            <span>{{ compensationNorAppealDetail.checkInfo.createTime | dateFormat }}</span>
          </div>
          <template v-if="compensationNorAppealDetail.type!==2">
            <div
              v-if="compensationNorAppealDetail.type===4 || compensationNorAppealDetail.type===1"
              class="flex-layout__wrap--item">
              <label v-if="compensationNorAppealDetail.appealInfo.appeal===0">已申诉</label>
              <label v-else-if="compensationNorAppealDetail.appealInfo.appeal===1">无需申诉</label>
            </div>
            <div
              v-else-if="compensationNorAppealDetail.type===3"
              class="flex-layout__wrap--item">
              <label>已扣罚</label>
            </div>
            <div
              v-else
              class="flex-layout__wrap--item">
              <label>申诉倒计时：</label>
              <span>
                <count-down
                  :type="1"
                  :end-time="compensationNorAppealDetail.checkInfo.expireTime"/>
              </span>
            </div>
          </template>
          <div class="flex-layout__wrap--item">
            <label>责任方：</label>
            <span>{{ compensationNorAppealDetail.checkInfo.duty }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>对供留言：</label>
            <span>{{ compensationNorAppealDetail.checkInfo.messageToSupplier || "无" }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 供应商申诉信息 -->
    <div
      v-if="compensationNorAppealDetail.type!==2"
      class="panel-wrap">
      <p class="panel-wrap__title">
        <span class="panel-wrap__title--icon"/>
        <span class="panel-wrap__title--text">供应商申诉信息</span>
      </p>
      <div class="panel-wrap__content">
        <div
          class="flex-layout__wrap flex-layout__wrap--mbuttom">
          <div class="flex-layout__wrap--item">
            <label>供应商截单时间：</label>
            <span>{{ compensationNorAppealDetail.appealInfo.supplierOrderCutTime | dateFormat }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>供应商推单时间：</label>
            <span>{{ compensationNorAppealDetail.appealInfo.supplierOrderCreateTime | dateFormat }}</span>
          </div>
        </div>
        <div
          v-if="compensationNorAppealDetail.appealInfo.timeout"
          class="flex-layout__wrap--item row-block"
          style="width: 100%">
          <p class="alert-text">超时未申诉</p>
        </div>
        <div
          v-if="compensationNorAppealDetail.type!==3"
          class="flex-layout__wrap flex-layout__wrap--mbuttom">
          <div
            class="flex-layout__wrap--item"
            style="width: 100%">
            <label class="icon-necessary__before">是否申诉：</label>
            <div>
              <el-radio
                v-model="compensationNorAppealDetail.appealInfo.appeal"
                :disabled="compensationNorAppealDetail.type!==0"
                :label="0">是</el-radio>
              <el-radio
                v-model="compensationNorAppealDetail.appealInfo.appeal"
                :disabled="compensationNorAppealDetail.type!==0"
                :label="1">否</el-radio>
            </div>
          </div>
          <template v-if="compensationNorAppealDetail.appealInfo.appeal===0">
            <div class="flex-layout__wrap--item">
              <label class="icon-necessary__before">是否有货：</label>
              <div>
                <el-radio
                  v-model="compensationNorAppealDetail.appealInfo.haveGoods"
                  :disabled="compensationNorAppealDetail.type!==0"
                  :label="0">是</el-radio>
                <el-radio
                  v-model="compensationNorAppealDetail.appealInfo.haveGoods"
                  :disabled="compensationNorAppealDetail.type!==0"
                  :label="1">否</el-radio>
              </div>
            </div>
            <div class="flex-layout__wrap--item">
              <label class="icon-necessary__before">责任方：</label>
              <select
                v-if="compensationNorAppealDetail.type===0"
                v-model="compensationNorAppealDetail.appealInfo.duty">
                <option :value="0">请选择责任方:</option>
                <option
                  v-for="item in dutyList"
                  :key="item.value"
                  :value="item.value">{{ item.text }}</option>
              </select>
              <span v-else>{{ compensationNorAppealDetail.appealInfo.duty }}</span>
            </div>
            <div class="flex-layout__wrap--item">
              <label class="icon-necessary__before">具体原因：</label>
              <select
                v-if="compensationNorAppealDetail.type===0"
                v-model="compensationNorAppealDetail.appealInfo.reason"
                :disabled="compensationNorAppealDetail.type!==0">
                <option :value="0">请选择具体原因:</option>
                <option
                  v-for="reason in reasonList"
                  :key="reason.value"
                  :value="reason.value">{{ reason.text }}</option>
              </select>
              <span v-else>{{ compensationNorAppealDetail.appealInfo.reason }}</span>
            </div>
            <div
              class="flex-layout__wrap--item w-50">
              <label suffix-colon>{{$t('explain')}}</label>
              <input
                v-model="compensationNorAppealDetail.appealInfo.explain"
                :disabled="compensationNorAppealDetail.type!==0"
                type="text" >
            </div>
            <div
              class="flex-layout__wrap--item w-50"
              style="width:100%">
              <label>{{$t('picPreview')}}：</label>
              <el-upload
                :on-preview="showSupplierPic"
                :disabled="compensationNorAppealDetail.type!==0"
                :before-remove="handleRemove"
                :file-list="compensationNorAppealDetail.appealInfo.pics"
                :show-file-list="true"
                :on-success="handleUploadImage"
                :before-upload="beforeUpload"
                :limit="3"
                :class="isNeedAdd"
                action="/bs/file/upload"
                list-type="picture-card">
                <i
                  v-if="compensationNorAppealDetail.appealInfo.pics.length<3 && compensationNorAppealDetail.type!==4 && compensationNorAppealDetail.type!==1"
                  class="el-icon-plus"/>
              </el-upload>
              <el-dialog
                :visible.sync="pictureDialogVisible"
                style="width:100%">
                <img
                  :src="dialogImageUrl"
                  width="100%"
                  alt="">
              </el-dialog>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 申诉结果 -->
    <div
      v-if="isShowAppealResult"
      class="panel-wrap">
      <p class="panel-wrap__title">
        <span class="panel-wrap__title--icon"/>
        <span class="panel-wrap__title--text">审核结果</span>
      </p>
      <div class="panel-wrap__content">
        <div class="flex-layout__wrap">
          <div class="flex-layout__wrap--item">
            <label>赔付状态：</label>
            <span>{{ compensationNorAppealDetail.appealResult.status }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>赔付金额：</label>
            <span>{{ `${compensationNorAppealDetail.appealResult.compensationAmount}元` }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>赔付原因：</label>
            <span>{{ compensationNorAppealDetail.appealResult.deal }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>确认赔付时间：</label>
            <span>{{ compensationNorAppealDetail.appealResult.auditTime | dateFormat }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>责任方：</label>
            <span>{{ compensationNorAppealDetail.appealResult.duty }}</span>
          </div>
          <div class="flex-layout__wrap--item">
            <label>对供留言：</label>
            <span>{{ compensationNorAppealDetail.appealResult.auditRemark }}</span>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-wrap">
      <button
        v-if="compensationNorAppealDetail.type===0"
        class="btn blue-btn"
        @click="dealSupplierAppeal">{{$t('ensure')}}</button>
      <button
        class="btn normal-btn"
        @click="handleGoBack">{{ $t('back') }} (Esc)</button>
    </footer>
    <v-modal ref="modal"/>
    <v-toast ref="toast"/>
    <v-pic-preview
      ref="picPreview"
      :image-arr="previewImg.imgArr"
      :index="previewImg.index"
      :can-edit="previewImg.canEdit"
      @upload-image="previewImg.uploadImage"
      @delete-image="previewImg.deleteImage"/>
  </div>
</template>
<script>
  import {
    getAppealDetail,
  } from '@/fetch/supplierAppeal';
  import detailMixin from './mixins/detailMixin';

  export default {
    name: 'compensationDetail',
    mixins: [detailMixin],
    created() {
      const { id } = this.$route.params;
      if (id) {
        this.handleAppealInfo(id);
      }
    },
    methods: {
      async handleAppealInfo(id) {
        try {
          const res = await getAppealDetail({ deductionId: id });
          if (res.success) {
            Object.keys(this.compensationNorAppealDetail).forEach(key => {
              this.compensationNorAppealDetail[key] = res.model[key];
              if (key === 'appealInfo' && res.model[key].pics && res.model[key].pics.length > 0) {
                this.compensationNorAppealDetail[key].pics = res.model[key].pics.map(item => ({
                  url: item,
                }));
              } else if (key === 'appealInfo' && !res.model[key].pics) {
                this.compensationNorAppealDetail[key].pics = [];
              }
            });
          } else {
            this.$refs.modal.$emit('ModalTip', res.msg || '网络错误！', () => { this.handleGoBack(); });
          }
        } catch (err) {
          console.log('error', err);
        }
      },
      handleGoBack() {
        const { lastName } = this.$route.params;
        this.$router.push({
          name: 'orderAppointment',
          query: {
            view: lastName === 'appeal' ? 2 : 1,
          },
        });
      },
    },
  };
</script>
<style lang="scss">
.upload-need .el-upload--picture-card {
  display: none;
}
</style>

<style lang="scss" scoped>
.deliveryEnsureDetail {
  padding: 0.12rem 0 0.5rem 0;
  background-color: $color-DDDDDD;
  .red-Border {
    border: 1px solid red;
  }
  .alert-text {
    padding-left: 0.3rem;
    font-size: 0.2rem !important;
    color: red !important;
  }
  .image-content {
    width: 100%;
    height: 100%;
    background-color: $color-FFFFFF;
    display: block;
  }
}
</style>
